import { makeVar } from '@apollo/client'

/** Referrer validated from `?referralCode=`; `signInPrivy` sends it with a new account. */
export const referrerIdVar = makeVar<string | null>(null)
